export default __webpack_public_path__ + "static/media/Lady.e149279d.webp";